module.exports = __webpack_public_path__ + "static/media/motorcycle.e093f303.svg";